"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
var assign = require('lodash/assign');

var _default = function wrapper() {
  function formInteractionEvent(info) {
    // Cache the NWA library for linting issues.
    var _window = window,
        nwa = _window.nwa; // Publish the form input changed ecvent with the provided info.

    if (nwa) {
      nwa.track('FORM_INPUT_CHANGED_EVENT', info);
    }
  }

  return {
    onInputChanged: formInteractionEvent,
    onFormOpen: function onFormOpen(info) {
      return formInteractionEvent(assign({
        action: 'FORM_OPEN',
        fieldName: '-'
      }, info));
    },
    onFormSubmit: function onFormSubmit(info) {
      return formInteractionEvent(assign({
        action: 'FORM_SUBMIT',
        fieldName: '-'
      }, info));
    },
    onFormCancel: function onFormCancel(info) {
      return formInteractionEvent(assign({
        action: 'FORM_CANCEL',
        fieldName: '-'
      }, info));
    },
    onFormMoveToPage: function onFormMoveToPage(info) {
      return formInteractionEvent(assign({
        action: 'FORM_MOVE_TO_PAGE',
        fieldName: '-'
      }, info));
    }
  };
}();

exports.default = _default;